// small icon that is used as the bookmark button
export const bookmarkIcon = `
<svg class="bookmark-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" data-button-state="unknown" data-status="loading">
  <path class="main-shape" stroke="#e2e2e2" fill="#e2e2e2" d="M19.24 21.47a.55.55 0 0 0 .26-.47V5A2.5 2.5 0 0 0 17 2.5H7A2.5 2.5 0 0 0 4.5 5v15.95a.5.5 0 0 0 .8.34l6.7-4.8.3.2 6.45 4.78a.5.5 0 0 0 .49 0Z"/>
  <g transform="translate(14)">
    <g display="none" class="icon-success">
      <circle cx="4.14" cy="4.14" r="4" fill="#7ED321"/>
      <path fill="#FFF" d="M5.75 2.13 3.47 4.46 2.41 3.45l-.75.75 1.81 1.76L6.5 2.88z"/>
    </g>
    <g display="none" class="icon-warning">
      <circle cx="4.14" cy="4.14" r="4" fill="#F5A623"/>
      <path fill="#FFF" d="M3.56 1.23h1.11v3.73H3.56z"/>
      <path fill="#FFF" d="M3.56 5.67h1.13v1.11H3.56z"/>
    </g>
    <g display="none" class="icon-error">
      <circle cx="4.14" cy="4.14" r="4" fill="#F52222"/>
      <path id="x" fill="#FFF" d="m4.95 4.12 1.46 1.46-.78.78L4.16 4.9 2.7 6.36l-.78-.78 1.46-1.46-1.46-1.47.78-.78 1.46 1.46 1.47-1.46.78.78z"/>
    </g>
  </g>
</svg>`;

// large decorative icon for use in modals etc
export const largeIcon = `<svg class="large-icon" xmlns="http://www.w3.org/2000/svg" width="121" height="120" fill="none" viewBox="0 0 121 120">
<g clip-path="url(#clip0_6240_16668)">
  <g filter="url(#filter0_i_6240_16668)">
    <circle cx="60.5" cy="60" r="60" fill="#EFEFEF"/>
  </g>
  <path fill="#000" stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M74 78 60 68 46 78V46a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v32Z"/>
</g>
<defs>
  <clipPath id="clip0_6240_16668">
    <path fill="#fff" d="M1 0h120v120H1z"/>
  </clipPath>
  <filter id="filter0_i_6240_16668" width="136" height="128" x=".5" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset dx="16" dy="8"/>
    <feGaussianBlur stdDeviation="12"/>
    <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"/>
    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
    <feBlend in2="shape" result="effect1_innerShadow_6240_16668"/>
  </filter>
</defs>
</svg>`;
